import { render, staticRenderFns } from "./ActivityBasicForm.vue?vue&type=template&id=2cbb4dce&scoped=true&"
import script from "./ActivityBasicForm.vue?vue&type=script&lang=js&"
export * from "./ActivityBasicForm.vue?vue&type=script&lang=js&"
import style0 from "./ActivityBasicForm.vue?vue&type=style&index=0&id=2cbb4dce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbb4dce",
  null
  
)

export default component.exports